import { atom } from "jotai";
import type { ShoppingCartResponse } from "@models/shoppingCart";

export const shoppingCartAtom = atom<ShoppingCartResponse | null>(null);

// No fetching or fetch-error atom (#407): the pages that read the cart keep the
// outcome of their own read (useMountRead). An app-scoped status outlived the
// page and painted the previous visit's failure on the next one's first frame.

export const isProcessingShoppingCartAtom = atom<boolean>(false);
